import React, { useState } from "react";
import { GamifiedQuizQuestionsProps } from "../types/GamifiedQuiz.type";
import { MultiChoice, MultiChoiceTwo } from "./MultiChoice";
import Label from "../../../../components/Modules/Label";
import Rating from "../../../../components/Rating/Rating";
import { LabelModule } from "../../onboarding/Modules/LabelModule";
import { TextInputModule } from "../../onboarding/Modules/TextInputModule";
import { NumberInputModule } from "../../onboarding/Modules/NumberInputModule";
import { EmailInputModule } from "../../onboarding/Modules/EmailInputModule";
import { DateInputModule } from "../../onboarding/Modules/DateInputModule";
import { TextAreaModule } from "../../onboarding/Modules/TextAreaModule";
import SingleChoice from "./SingleChoice";

export const GamifiedQuizQuestions: React.FC<GamifiedQuizQuestionsProps> = ({
  question,
  formdata,
  answer,
  handleUpdate,
  handleCheckboxChange,
  handleRadioChange,
  handleRatingChange,
  selectedOptions,
  newId,
  themeManager,
  singleChoiceModal,
  multiChoiceModal,
  ratingType,
  validateInputRegex,
}) => {
  const questionIndex = question - 1;
  const value = formdata[questionIndex];
  if (!value) return null;

  // console.log("value", value);
  // console.log("formdata", formdata);

  const selectedOption =
    answer && value[newId] && Array.isArray(answer[value[newId]])
      ? answer[value[newId]][0]
      : null;
  const questionId = value[newId] || "";

  const selectedOptionModal2 =
    answer && questionId && Array.isArray(answer[questionId])
      ? answer[questionId][0]?.value || ""
      : "";

  const emailError = themeManager.getEmailTextStyles();

  // console.log("validateInputRegex", validateInputRegex);
  // console.log("value", value);
  // console.log("formdata", formdata);


  return (
    <div className="gamified-quiz-action-div">
      <div className="gamified-quiz-header-ques-title-cont">
        <div className="question-input-cont">
          <div className="gamified-quiz-criteria-div">
            {(value?.type === "USER_INPUT_SINGLE_CHOICE" ||
              value?.type === "USER_INPUT_MULTI_CHOICE") && (
              <div
                className="question"
                style={themeManager.getQuestionContainerStyles()}
              >
                {value?.question}
                {`${value?.required ? "*" : ""}`}
              </div>
            )}

            {value.type === "USER_INPUT_TEXT" && (
              <>
                <div className="label-input-cont">
                  <LabelModule htmlFor="" style={themeManager.getLabelStyles()}>
                    {`${value?.question || ""} ${!!value?.required ? "*" : ""}`}
                  </LabelModule>
                  <TextInputModule
                    placeholder={value?.placeholder || value?.question || ""}
                    value={answer[value?.actionId || ""]}
                    regexKey={value?.regexKey}
                    regexMessage={value?.regexMessage}
                    validateInputRegex={(validation) =>
                      // console.log(validation, value.regexKey)
                      validateInputRegex(validation, value.actionId)
                    }
                    errorText={themeManager.getTextInputErrorText()}
                    textErrorStyle={themeManager.getTextInputErrorStyles()}
                    onChange={(e: any) =>
                      handleUpdate(e, value.actionId || "", "")
                    }
                    style={themeManager.getTextInputStyles()}
                  />
                </div>
              </>
            )}

            {value.type === "USER_INPUT_EMAIL" && (
              <>
                <div className="label-input-cont" key={value?.actionId}>
                  <LabelModule htmlFor="" style={themeManager.getLabelStyles()}>
                    {`${value?.question || ""} ${!!value?.required ? "*" : ""}`}
                  </LabelModule>
                  <EmailInputModule
                    placeholder={value?.placeholder || value?.question || ""}
                    value={answer[value?.actionId || ""]}
                    iconColor={themeManager.getEmailIconColor()}
                    validateInputRegex={(validation) =>
                      validateInputRegex(validation, value.actionId)
                    }
                    regexKey={value?.regexKey}
                    regexMessage={value?.regexMessage}
                    onChange={(e: any) =>
                      handleUpdate(e, value.actionId || "", "")
                    }
                    style={themeManager.getTextInputStyles()}
                    emailtext={themeManager.getEmailInputErrorText()}
                    emailErrorStyle={themeManager.getEMailInputErrorStyles()}
                  />
                </div>
              </>
            )}
            {(value?.type === "USER_INPUT_PHONE" ||
              value?.type === "USER_INPUT_NUMBER") && (
              <div className="label-input-cont-question" key={value.actionId}>
                <LabelModule htmlFor="" style={themeManager.getLabelStyles()}>
                  {`${value?.question || ""} ${!!value?.required ? "*" : ""}`}
                </LabelModule>

                <NumberInputModule
                  placeholder={value?.placeholder || value?.question || ""}
                  value={answer[value.actionId || ""]}
                  iconColor={themeManager.getEmailIconColor()}
                  validateInputRegex={(validation) =>
                    validateInputRegex(validation, value.actionId)
                  }
                  numbertext={themeManager.getNumberInputErrorText()}
                  numberErrorStyle={themeManager.getNumberInputErrorStyles()}
                  regexKey={value?.regexKey}
                  regexMessage={value?.regexMessage}
                  onChange={(e: any) =>
                    handleUpdate(e, value.actionId || "", "")
                  }
                  style={themeManager.getTextInputStyles()}
                  key={value?.actionId}
                />
              </div>
            )}
            {value.type === "USER_INPUT_DATE" && (
              <>
                <div className="label-input-cont-question" key={value.actionId}>
                  <LabelModule htmlFor="" style={themeManager.getLabelStyles()}>
                    {`${value?.question || ""} ${!!value?.required ? "*" : ""}`}
                  </LabelModule>
                  <DateInputModule
                    placeholder={value?.placeholder || value?.question || ""}
                    value={answer[value.actionId || ""]}
                    onChange={(e: any) =>
                      handleUpdate(e, value.actionId || "", "")
                    }
                    iconColor={themeManager.getEmailIconColor()}
                    style={themeManager.getTextInputStyles()}
                    // key={value.actionId}
                    preventFutureSelection={true}
                    preventPastSelection={false}
                    minDate=""
                    maxDate=""
                  />
                </div>
              </>
            )}
            {value.type === "USER_INPUT_TEXTAREA" && (
              <>
                <div className="label-input-cont-question">
                  <LabelModule htmlFor="" style={themeManager.getLabelStyles()}>
                    {`${value?.question || ""} ${!!value?.required ? "*" : ""}`}
                  </LabelModule>
                  <TextAreaModule
                    value={answer[value.actionId || ""]}
                    onChange={(e: any) =>
                      handleUpdate(e, value.actionId || "", "")
                    }
                    style={themeManager.getTextAreaInputStyles()}
                    textareatext={themeManager.getTextAreaInputErrorText()}
                    textareaErrorStyle={themeManager.getTextAreaInputErrorStyles()}
                    validateInputRegex={(validation) =>
                      validateInputRegex(validation, value.actionId)
                    }
                    placeholder={value?.placeholder || value?.question || ""}
                    key={value?.actionId}
                  />
                </div>
              </>
            )}

            {value.type === "RATING" && (
              <div className="mb-4">
                <Label
                  className="q-fd-lebels"
                  style={themeManager.getLabelStyles()}
                >
                  {`${value.question ? value.question : "Rating Scale"}${
                    value.required === true ? "*" : ""
                  }`}
                </Label>
                <div
                  style={{
                    display: "flex",
                    marginTop: "6px",
                  }}
                >
                  <Rating
                    count={5}
                    getCurrentRating={(item) =>
                      handleRatingChange(value.actionId, item)
                    }
                    defaultRating={Number(answer[value?.actionId])}
                    RatingStyle={themeManager.getRatingStyles()}
                    type={value?.metadata?.ratingType || ratingType}
                    leftText={value?.metadata?.leftRatingText}
                    rightText={value?.metadata?.rightRatingText}
                    centerRatingText={value?.metadata?.centerRatingText}
                  />
                </div>
              </div>
            )}

            {value.type === "USER_INPUT_MULTI_CHOICE" &&
              (multiChoiceModal === "modal1" ? (
                <MultiChoiceTwo
                  options={value.options}
                  checked={
                    !!selectedOptions[value[newId]] &&
                    selectedOptions[value[newId]]
                  }
                  onChange={(e: any) =>
                    handleCheckboxChange(e.target.value, value[newId])
                  }
                  style={themeManager.getMultiChoiceBorderStyle()}
                  selectedStyle={themeManager.getMultiChoiceSelectedColorStyles()}
                />
              ) : (
                <MultiChoice
                  options={value.options}
                  checked={selectedOptions[value[newId]]}
                  onChange={(e: any) =>
                    handleCheckboxChange(e.target.value, value[newId])
                  }
                  style={themeManager.getMultiChoiceStyles()}
                  selectedStyle={themeManager.getMultiChoiceSelectedStyles()}
                />
              ))}

            {value.type === "USER_INPUT_SINGLE_CHOICE" && (
              <div
                style={{
                  // width: singleChoiceModal === "modal2" ? "91%" : "100%",
                }}
              >
                <SingleChoice
                  options={value.options}
                  type={singleChoiceModal}
                  checked={
                    singleChoiceModal === "modal3"
                      ? selectedOptionModal2
                      : selectedOption
                  }
                  onChange={(e: any) =>
                    singleChoiceModal === "modal3"
                      ? handleRadioChange(e, questionId, "")
                      : handleRadioChange(e.target.value, questionId, "radio")
                  }
                  style={themeManager.getSingleChoiceStyles()}
                  hoverBackground={themeManager.getSingleChoiceHoverStyles()}
                  selectedStyle={themeManager.getSingleChoiceSelectedStyles()}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
